module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-6.0c96c10d.jpg";